import Axios from 'axios'

import { getCookie } from '../utils/auth-utils'
import strings from '../strings'

const resultHistory = {
  axios() {
    let AxiosInstance = Axios.create({
      baseURL: process.env.RESULTS_HISTORY,
      headers: {
        Authorization: strings.headers.bearerAuthentication + getCookie('token_aol')
      }
    })
    return AxiosInstance
  },
  axiosExternalURL() {
    let AxiosInstance = Axios.create({
      baseURL: process.env.LAUDOS_API,
      headers: {
        Authorization: strings.headers.bearerAuthentication + getCookie('token_aol')
      }
    })

    return AxiosInstance
  },
  getResultsHistoryByFilter(data) {
    const filters = {
      serviceOrder: data && data.serviceOrder ? `&serviceOrder=${data.serviceOrder}` : '',
      patientName: data && data.patientName ? `&patientName=${data.patientName}` : '',
      byResultDate: data && data.byResultDate ? `&byResultDate=${data.byResultDate}` : '',
      page: (data && data.page) || 1
    }

    return this.axios().get(
      `/getHistoricalReport?page=${filters.page}${filters.patientName}${filters.serviceOrder}${filters.byResultDate}`
    )
  },
  downloadResultsHistory(os) {
    return this.axiosExternalURL().get(`laudos/historico/pdf?id=${os}`, {
      responseType: 'arraybuffer'
    })
  }
}

export default resultHistory
